/**
 * VOMI brand color palette — single source of truth for both frontends.
 * Primary palette from frontend/ VomiPreset (canonical).
 */
export const VOMI_COLORS = {
  primary: {
    50: '#F1F5F2',
    100: '#D9E1D8',
    200: '#B7C5B7',
    300: '#94AA96',
    400: '#7E9B80',
    500: '#889D90',
    600: '#6B7B6B',
    700: '#556255',
    800: '#404A40',
    900: '#2B322B',
    950: '#191D19',
  },
  pink: {
    DEFAULT: '#CB9FA5',
    surface: '#FCE8F0',
    light: '#F4E8EC',
    dark: '#C49AAE',
    border: '#F0D5E0',
    card: '#F8EFF3',
  },
  mint: {
    DEFAULT: '#8B9D90',
    light: '#93A89A',
    surface: '#E8F5E9',
    border: '#D1DDD2',
    card: '#F0F4F1',
  },
  sand: '#CCCBC4',
  surface: {
    DEFAULT: '#F8FAF9',
    mint: '#F5F7F5',
    pink: '#F9F5F7',
    card: '#FFFFFF',
  },
  text: {
    DEFAULT: '#1A1A1A',
    secondary: '#6B7280',
    muted: '#9CA3AF',
  },
  gray: {
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#111827',
  },
  border: {
    DEFAULT: '#E5E7EB',
    light: '#F3F4F6',
    mint: '#D1DDD2',
    pink: '#F0D5E0',
  },
  status: {
    success: '#889D90',
    warning: '#F59E0B',
    error: '#EF4444',
  },
} as const;

/**
 * Tailwind-ready color config — import into tailwind.config.js:
 *   import { TAILWIND_COLORS } from '../packages/shared/src/theme/colors';
 *   theme: { extend: { colors: TAILWIND_COLORS } }
 */
export const TAILWIND_COLORS = {
  primary: {
    DEFAULT: VOMI_COLORS.primary[500],
    light: VOMI_COLORS.primary[200],
    dark: VOMI_COLORS.primary[700],
    hover: VOMI_COLORS.primary[600],
  },
  mint: {
    DEFAULT: VOMI_COLORS.mint.DEFAULT,
    surface: VOMI_COLORS.mint.surface,
    light: VOMI_COLORS.primary[100],
    border: VOMI_COLORS.primary[200],
    card: VOMI_COLORS.primary[50],
  },
  secondary: {
    DEFAULT: VOMI_COLORS.pink.DEFAULT,
    light: VOMI_COLORS.pink.light,
    dark: VOMI_COLORS.pink.dark,
  },
  pink: VOMI_COLORS.pink,
  gray: VOMI_COLORS.gray,
  accent: {
    DEFAULT: '#B8B5A7',
    light: '#D4D1C7',
  },
  surface: VOMI_COLORS.surface,
  text: VOMI_COLORS.text,
  border: VOMI_COLORS.border,
  sand: VOMI_COLORS.sand,
  success: VOMI_COLORS.status.success,
  warning: VOMI_COLORS.status.warning,
  error: VOMI_COLORS.status.error,
  tint: VOMI_COLORS.primary[500],
  tab: {
    default: '#B8B5A7',
    selected: VOMI_COLORS.primary[500],
  },
} as const;
